import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, onlyUpdateForKeys, branch } from 'recompose'
import classNames from 'classnames'
import { AsyncEditor } from '@slite/editor'
import ErrorBoundary from 'components/Utils/ErrorBoundary'
import withComponent from 'components/Utils/hoc/withComponent'

import './style.css'

class MainEditor extends Component {
  static propTypes = {
    value: PropTypes.object,
    readOnly: PropTypes.bool.isRequired,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    noteEditor: PropTypes.bool,
    commentEditor: PropTypes.bool,
    plugins: PropTypes.any,
    hasEditorNextFeatureFlag: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onEditorRef: PropTypes.func,
  }

  static defaultProps = {
    onEditorRef: () => {},
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus()
    }
  }

  focus = () => {
    if (this.editorRef && this.editorRef.editor) {
      this.props.onChange(this.editorRef.editor.focus())
    }
  }

  onEditorRef = editorRef => {
    this.editorRef = editorRef
    this.props.onEditorRef(editorRef)
  }

  render() {
    const {
      value,
      onChange,
      onError,
      readOnly,
      noteEditor,
      commentEditor,
      plugins,
      placeholder,
    } = this.props

    const className = classNames(
      'slite-design-system',
      'fs-block data-hj-suppress' /* fs-block & data-hj-suppress hides content for FullStory & Hotjar */,
      {
        'note-editor': noteEditor,
        'comment-editor': commentEditor,
      }
    )

    if (!value) {
      return this.props.loadingState || false
    }

    const EditorComponent = this.props.Component
    return (
      <ErrorBoundary noCrashScreen>
        <div className={className}>
          <EditorComponent
            {...this.props}
            value={value}
            readOnly={readOnly}
            spellCheck={!readOnly}
            placeholder={placeholder}
            plugins={plugins}
            onEditorRef={this.onEditorRef}
            onChange={onChange}
            onError={onError}
            logPerformances={noteEditor}
          />
        </div>
      </ErrorBoundary>
    )
  }
}

export default compose(
  onlyUpdateForKeys(['readOnly', 'value', 'hasEditorNextFeatureFlag']),
  branch(
    ({ hasEditorNextFeatureFlag }) => hasEditorNextFeatureFlag,
    withComponent(() =>
      import(/* webpackChunkName: "editor-next" */ './EditorNext')
    ),
    withComponent(() => AsyncEditor)
  )
)(MainEditor)
